export default function blog_slider() {
  const slider = document.querySelector(".blog_slider_list");
  const prevButton = document.querySelector(".blog_page_slider .blog_prev_slide");
  const nextButton = document.querySelector(".blog_page_slider .blog_next_slide");

  if (!slider || !prevButton || !nextButton) {
    return;
  }


  const sliderItems = document.querySelectorAll(".blog_slider_list .blog_slider_item");
  const totalItems = sliderItems.length;

  let visibleItems = 2;  // dafault
  let currentIndex = 0;
  let maxIndex = totalItems - visibleItems;
  let gap = 20;

  // var for swipe
  let startX = 0;
  let currentX = 0;
  let isDragging = false;

  currentIndexCheck();
  updateVisibleItems();
  window.addEventListener('resize', updateVisibleItems);

  prevButton.addEventListener("click", () => {
    if (currentIndex > 0) {
      currentIndex--;
      updateSliderPosition();
      currentIndexCheck();
    }
  });

  nextButton.addEventListener("click", () => {
    if (currentIndex < maxIndex) {
      currentIndex++;
      updateSliderPosition();
      currentIndexCheck();
    }
  });

  // swiping
  slider.addEventListener("touchstart", (e) => {
    startX = e.touches[0].clientX;
    isDragging = true;
    slider.style.transition = "none";
  });

  slider.addEventListener("touchmove", (e) => {
    if (!isDragging) return;
    currentX = e.touches[0].clientX;
    const deltaX = startX - currentX;
    const offset = currentIndex * (sliderItems[0].offsetWidth + gap) + deltaX;

    slider.style.transform = `translateX(-${offset}px)`;
  });

  slider.addEventListener("touchend", (e) => {
    if (!isDragging) return;
    isDragging = false;
    slider.style.transition = "transform 0.5s ease";

    const deltaX = startX - currentX;

    if (deltaX > 50 && currentIndex < maxIndex) {
      currentIndex++;
    } else if (deltaX < -50 && currentIndex > 0) {
      currentIndex--;
    }
    currentIndexCheck();
    updateSliderPosition();
  });

  function updateSliderPosition() {
    const offset = currentIndex * (sliderItems[0].offsetWidth + gap);
    slider.style.transform = `translateX(-${offset}px)`;
  };

  function currentIndexCheck() {
    if (currentIndex <= 0) {
      prevButton.setAttribute('disabled', true);
    } else {
      prevButton.removeAttribute('disabled');
    }
    if (currentIndex >= maxIndex) {
      nextButton.setAttribute('disabled', true);
    } else {
      nextButton.removeAttribute('disabled');
    }
  }


  function updateVisibleItems() {
    if (window.innerWidth < 768) {
      visibleItems = 2;
      gap = 12;
    } else {
      gap = 20;
      visibleItems = 2;
    }
    maxIndex = totalItems - visibleItems;
    currentIndexCheck();
  }
}
